export function ScreenBreakpointIndicator() {
  return (
    <div className='fixed z-50 top-0 left-1.5 sm:left-1/2 sm:-translate-x-1/2 gap-1.5 flex items-center pointer-events-none justify-center'>
      <div className='flex flex-center rounded-b bg-emerald-200 short:bg-emerald-400 medium:bg-emerald-600 tall:bg-emerald-800 text-neutral-950 medium:text-neutral-50 py-0.5 px-2.5 text-xs'>
        <span className='inline short:hidden'>{'<Short'}</span>
        <span className='hidden short:inline medium:hidden'>Short</span>
        <span className='hidden medium:inline tall:hidden'>Medium</span>
        <span className='hidden tall:inline'>Tall</span>
      </div>

      <div className='flex flex-center rounded-b bg-rose-200 landscape:bg-rose-800 text-neutral-950 landscape:text-neutral-50 py-0.5 px-2.5 text-xs'>
        <span className='inline landscape:hidden'>Portrait</span>
        <span className='hidden landscape:inline'>Landscape</span>
      </div>

      <div className='flex flex-center rounded-b bg-indigo-100 xxs:bg-indigo-200 xs:bg-indigo-300 sm:bg-indigo-400 md:bg-indigo-500 lg:bg-indigo-600 xl:bg-indigo-700 2xl:bg-indigo-800 3xl:bg-indigo-900 md:text-neutral-50 text-neutral-950 py-0.5 px-2.5 text-xs'>
        <span className='inline xxs:hidden'>{'<XXS'}</span>
        <span className='hidden xs:!hidden xxs:inline'>XXS</span>
        <span className='hidden sm:!hidden xs:inline'>XS</span>
        <span className='hidden sm:inline md:hidden'>SM</span>
        <span className='hidden md:inline lg:hidden'>MD</span>
        <span className='hidden lg:inline xl:hidden'>LG</span>
        <span className='hidden xl:inline 2xl:hidden'>XL</span>
        <span className='hidden 2xl:inline 3xl:hidden'>2XL</span>
        <span className='hidden 3xl:inline 4xl:hidden'>3XL</span>
        <span className='hidden 4xl:inline 5xl:hidden'>4XL</span>
        <span className='hidden 5xl:inline 6xl:hidden'>5XL</span>
        <span className='hidden 6xl:inline'>6XL</span>
      </div>
    </div>
  );
}
